module.exports = __webpack_public_path__ + "static/media/add_job.8e3d28b1.svg";